import React, { useContext, useState, memo, useEffect } from 'react'; 
import { Offcanvas } from 'react-bootstrap';
import { SocketContext, UserContext } from '../context/UserContext';


const Cards = memo(({ obj, isEmpty = true, toggleMic, leaveSeat, handleRetryConsume }) => {
  const [showActionModel, setShowActionModel] = useState(false);
  const { globalUser } = useContext(UserContext);
  const [count, setCount] = useState(0)
  const { socket } = useContext(SocketContext)
  const handleButtonCliclk = (userid, functionname) => {
    setShowActionModel(false)
    if(functionname === "LeaveSeat"){
      leaveSeat(userid)
    }
  }
  // useEffect(()=>{
  //   socket.on("UserSpeak", handleUserSpeak);

  //   return () => {
  //     socket.off("UserSpeak")
  //   }
  // },[socket])

  const userTimeouts = new Map(); // Store timeouts per user

  const handleUserSpeak = ({UserID}) => {
      const userDiv = document.getElementById(`cnt${UserID}`);
  
      if (userDiv) {
          userDiv.classList.add("speak");
  
          // Clear previous timeout if it exists
          if (userTimeouts.has(UserID)) {
              clearTimeout(userTimeouts.get(UserID));
          }
  
          // Set a new timeout to remove the class
          const timeout = setTimeout(() => {
              userDiv.classList.remove("speak");
              userTimeouts.delete(UserID); 
          }, 500);
  
          // Store the new timeout
          userTimeouts.set(UserID, timeout);
      } else {
          // console.warn(`Div with ID ${UserID} not found`);
      }


        const micdiv = document.getElementById(`mic${UserID}`);
        if (micdiv) {
          const iElement = micdiv.querySelector('i');
          micdiv.classList.add('micdivon')
          micdiv.classList.remove('micdivoff')
          iElement.classList.remove('bi-mic-mute-fill')
          iElement.classList.add('bi-mic-fill')
        }


        //Check For Proper Audio
        
    


  };
  
  // Conditional rendering for the empty seat
  if (isEmpty) {
    return (
      <div
        className="card m-auto bg-transparent mb-3 d-flex justify-content-center align-items-center"
        style={{ aspectRatio: '1 / 1' }}
      >
        <i className="bi bi-ban" style={{ fontSize: 30 }}></i>
        <p className="m-0" style={{ fontSize: 10 }}>
          Empty Seat
        </p>
      </div>
    );
  }

  // Host badge
  const hostBadge = (obj?.isHost && obj?.seatNo == 1) ? (
    <div
      className="text-white bg-danger fw-bold rounded-pill px-1 ms-1 mt-1"
      style={{
        position: 'absolute',
        fontSize: 8,
        // background: 'rgba(94, 94, 94, 0.5)',
        // border: '1px solid White'
      }}
    >
      Live Host
    </div>
  ) : '';

  // Options button for host
  // const optionsButton = obj?.isHost ? (
  //   <div onClick={(obj?.userID == globalUser?.ID || globalUser?.isHost) ? () => setShowActionModel(true) : null}
  //     className="text-dark fw-bold rounded-pill ms-1 mt-1"
  //     style={{
  //       position: 'absolute',
  //       right: 5,
  //       fontSize: 12,
  //       background: 'white',
  //       cursor: 'pointer',
  //     }}
  //   >
  //     <i className="bi bi-three-dots-vertical"></i>
  //   </div>
  // ) : '';

  const optionsButton =  (
    <div onClick={(obj?.userID === globalUser?.ID || globalUser?.isHost) ? () => setShowActionModel(true) : null}
      className="text-dark fw-bold rounded-pill ms-1 mt-1"
      style={{
        position: 'absolute',
        right: 5,
        fontSize: 12,
        background: 'white',
        cursor: 'pointer',
      }}
    >
      <i className="bi bi-three-dots-vertical"></i>
    </div>
  );

  // User's profile picture or default avatar
  const profileImage = obj?.profile
    ? `data:image/jpeg;base64,${obj.profile}`
    : 'https://www.shutterstock.com/image-vector/default-avatar-profile-icon-vector-600nw-1725655669.jpg';

  return (
    <>
      <div
        id={`cnt${obj?.userID}`}
        className={`card m-auto mb-3`} 
        style={{ aspectRatio: '1 / 1', position: 'relative' }}
      >
        {hostBadge}
        {optionsButton}
        <img
          className="img-fluid rounded"
          style={{ aspectRatio: '1 / 1' }}
          src={profileImage}
          alt="Profile"
        />
        <div
          style={{
            position: 'absolute',
            bottom: 2,
            left:2,
            width: '100%',
            display:'flex',
            justifyContent:'center',
            alignItems:'center'
          }}
        >
          <div>
            {/* Toggle mic button */}
            <div id={`mic${obj.userID}`}
              onClick={() => toggleMic(obj.userID)}
              style={{
                width: '22px',
                fontSize: 12,
                padding: '2px',
                cursor: 'pointer',
                // backgroundColor: obj?.isMicOn ? 'white' : 'red',
                // color: obj?.isMicOn ? 'red' : 'white',
              }}
              className={`rounded-circle m-auto micDiv${obj?.isMicOn ? 'on' : 'off'}`}
              >
              <i
                className={`bi ${
                  obj?.isMicOn ? 'bi-mic-fill' : 'bi-mic-mute-fill'
                }`}
                ></i>
            </div>
          </div>
          {/* Producer name */}
          <div
            style={{
              fontSize: 10,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              textShadow:
              '1px 0 black, -1px 0 black, 0 1px black, 0 -1px black',
            }}
            className="text-white w-100 text-start ps-2"
            >
            {obj?.producerName}
          </div>
        </div>
        {/* Audio stream */}
        {obj?.stream && (
          <audio
          className="d-none"
          ref={(audioElement) => {
            if (audioElement) {
              // Set the stream as the source for the audio element
              audioElement.srcObject = obj?.stream;
        

              // Check if the audio element has a stream
              // if (audioElement.srcObject) {
              //   console.log('Audio stream set successfully', obj?.userID);
              // } else {
              //   console.log('Audio stream is missing', obj?.userID);
              // }


              if (audioElement.currentTime === 0 && count < 3) {
                setTimeout(() => {
                  if (audioElement.currentTime === 0) { 
                    handleRetryConsume(obj?.producerId);
                    setCount((prevCount) => prevCount + 1);
                  }
                }, 2000);
              }else{
                setCount(0)
              }
               
        
              // Check if audio is playing
              // audioElement.onplay = () => {
              //   console.log('Audio is now playing', obj?.userID);
              // };

              // audioElement.onerror = (error) => {
              //   console.error('Audio error:', error);
              // };
        
              // // Check if the audio is paused
              // audioElement.onpause = () => {
              //   console.log('Audio is paused', obj?.userID);
              // };
        
              // Check if the audio is playing after 1 second
              // setInterval(() => {
              //   if (audioElement.paused) {
              //     console.log('Audio is not playing');
              //   } else {
              //     console.log('Audio is playing');
              //   }
              // }, 1000);
            }
          }}
          controls
          autoPlay
        />
        
        )}
      </div>


      <Offcanvas className='rounded-top h-auto' show={showActionModel} onHide={() => setShowActionModel(false)} placement="bottom">
        <Offcanvas.Header className=' border-bottom'>
          <Offcanvas.Title className='text-center w-100'>Seat Option - {obj?.userID}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
        {(obj?.userID === globalUser?.ID && !globalUser?.isHost) ? (
          <>
            <button onClick={() => handleButtonCliclk(obj?.userID, "LeaveSeat")} className='btn btn-outline-danger w-100 mb-1 shadow-none btn-sm'>
              <i className="bi bi-ban me-2 text-danger"></i>Leave Seat
            </button>
          </>
        ) : (obj?.userID !== globalUser?.ID && globalUser?.isHost)? (
          <>
           <button onClick={() => handleButtonCliclk(obj?.userID, "LeaveSeat")} className='btn btn-outline-danger w-100 mb-1 shadow-none btn-sm'>
              <i className="bi bi-ban me-2 text-danger"></i>Remove From Seat
            </button>
          </>
        ) : (<div>No Action</div>)}
        </Offcanvas.Body>
      </Offcanvas>
     
    </>
  );
});

export default Cards;
